import { render, staticRenderFns } from "./what-is-giftcard-number-modal.vue?vue&type=template&id=51663226&lang=pug"
import script from "./what-is-giftcard-number-modal.vue?vue&type=script&lang=js"
export * from "./what-is-giftcard-number-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports